import { render, staticRenderFns } from "./TariffModifierForm.vue?vue&type=template&id=3227de65&"
import script from "./TariffModifierForm.vue?vue&type=script&lang=js&"
export * from "./TariffModifierForm.vue?vue&type=script&lang=js&"
import style0 from "./TariffModifierForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports